import { render, staticRenderFns } from "./CarRecordList.vue?vue&type=template&id=1cf0acb2&scoped=true"
import script from "./CarRecordList.vue?vue&type=script&lang=js"
export * from "./CarRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf0acb2",
  null
  
)

export default component.exports